import { useMutation } from "@tanstack/react-query"

import { QUERY_KEYS } from "../../constants"
import { editParent } from "../../networking/users/api"
import { queryClient } from "../../util/queryClient"

const useEditParentMutation = () => {
  return useMutation({
    mutationFn: editParent,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries([QUERY_KEYS.FAMILY]),
        queryClient.invalidateQueries([QUERY_KEYS.USER]),
      ])
    },
    onError: (error) => {
      console.error(error)
    },
  })
}

export default useEditParentMutation
